import { Inbox, RefreshCw, Send } from 'lucide-react';

import { defineArea } from '../../app/area';
import { InboxPage } from './pages/InboxPage';
import { OutboxPage } from './pages/OutboxPage';
import { SyncDashboardPage } from './pages/SyncDashboardPage';

/**
 * OWNER: the `bc-integration` module agent (M8 — docs/MODULES.md; also owns
 * `bc-extension/`).
 * Owns: apps/web/src/areas/bc-integration/**  ·  apps/api/src/modules/bc-integration/**
 *       packages/shared/src/contracts/bc-integration.ts
 *       packages/shared/src/i18n/{sv,en,zh}/bcIntegration.json  ·  e2e/bc-integration.md
 *
 * The sandbox/production environment banner lives in `components/EnvironmentBanner`
 * and is rendered by each page in this area — the shell never learns about BC.
 */
export default defineArea({
  id: 'bc-integration',
  nav: [
    {
      section: 'integration',
      to: '/integration/sync',
      labelKey: 'common:nav.integration.dashboard',
      icon: RefreshCw,
      permissions: ['integration.sync.read'],
      order: 10,
    },
    {
      section: 'integration',
      to: '/integration/outbox',
      labelKey: 'common:nav.integration.outbox',
      icon: Send,
      permissions: ['integration.sync.read'],
      order: 20,
    },
    {
      section: 'integration',
      to: '/integration/inbox',
      labelKey: 'common:nav.integration.inbox',
      icon: Inbox,
      permissions: ['integration.sync.read'],
      order: 30,
    },
  ],
  routes: [
    { path: 'integration/sync', element: <SyncDashboardPage /> },
    { path: 'integration/outbox', element: <OutboxPage /> },
    { path: 'integration/inbox', element: <InboxPage /> },
  ],
});
